/**
 * Names for people shown on the eMoney report (who corrected, checked off
 * or noted something). Cognito usernames are often the account's id (a
 * UUID), which means nothing to a reader, so they are never shown as a name.
 */

const ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isAccountId = (text) => ID_PATTERN.test(String(text || '').trim());

/** The signed-in user's name: full name, trader name, email, then a username that isn't an id. */
export const displayNameOf = (user) => {
  if (!user) return null;
  const candidates = [user.full_name, user.trader_name, user.email, user.username];
  const found = candidates.map((c) => String(c || '').trim()).find((c) => c && !isAccountId(c));
  return found || null;
};

/**
 * The name to show for a stored "by". Older annotations may hold an account
 * id: shown as the signed-in user's name when it is theirs, else "Unknown user".
 * viewer: { name, ids } for the signed-in user.
 */
export const personName = (by, viewer) => {
  const text = String(by || '').trim();
  if (!text) return 'Unknown user';
  if (!isAccountId(text)) return text;
  if (viewer && viewer.name && (viewer.ids || []).includes(text)) return viewer.name;
  return 'Unknown user';
};
